import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getManagedReturnsMetrics } from "./schema/get-managed-returns-metrics";
import { getRefulfillmentMetrics } from "./schema/get-refulfillment-metrics";

export const rpcDefinition = {
  getManagedReturnsMetrics,
  getRefulfillmentMetrics,
};

export type RedoManagedReturnsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
